import { buildThreadItemProps } from './threadItemFactory';
import { ThreadItemController } from './threadItemInterface';

export function createThreadItemController(): ThreadItemController {
    return {
        useProps(context, item, props) {
            return buildThreadItemProps(item, props);
        },
    };
}
